<template>
    <div :class="wrapClasses">
      <div :class="inputWrapClasses">
        <input
            :id="elementId"
            :class="inputClasses"
            :disabled="disabled"
            autocomplete="off"
            spellcheck="false"
            :autofocus="autofocus"
            @focus="focus"
            @blur="blur"
            @input="change"
            ref="precisionCursor"
            :maxlength='maxlength'
            @change="change"
            :readonly="readonly || !editable"
            :name="name"
            :value="currentValue"
            :placeholder="placeholder">
      </div>
    </div>
</template>
<script>
/* eslint-disable no-restricted-globals */
const prefixCls = 'ivu-input-number';
function broadcast(componentName, eventName, params) {
  this.$children.forEach((child) => {
    const name = child.$options.name;

    if (name === componentName) {
      // eslint-disable-next-line prefer-spread
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      // todo 如果 params 是空数组，接收到的会是 undefined
      broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}
function findComponentUpward(context, componentName, componentNames) {
  if (typeof componentName === 'string') {
    componentNames = [componentName];
  } else {
    componentNames = componentName;
  }

  let parent = context.$parent;
  let name = parent.$options.name;
  while (parent && (!name || componentNames.indexOf(name) < 0)) {
    parent = parent.$parent;
    if (parent) name = parent.$options.name;
  }
  return parent;
}
function roundFun(value, n, ifNeedCheckAllNumber, frontDecimal, activeChange) {
  //验证小数也可以验证小数前面的数量
  const testVal = value.toString();
  // eslint-disable-next-line prefer-template
  if (ifNeedCheckAllNumber) {
    if(new RegExp('^\\-?\\d{0,'+frontDecimal+'}\\.?(\\.\\d{0,'+n+'})?$').test(testVal)) {
      return value;
    } else {
      if (!activeChange) {
        alert(`小数点前后最多可以输入${frontDecimal}位和${n}位，请按照要求填写`);
        return null;
      }
      let dotIndex = testVal.indexOf('.');
      if (dotIndex !== -1) {//小数点存在
        if (dotIndex > frontDecimal) {
          let temp = testVal;
          let testValArr = temp.split('');
          testValArr[frontDecimal] = '';
          temp = testValArr.join('');
          return temp;
        }
        let res = testVal.slice(0, dotIndex + n + 1);
        return res;
      } else {//小数点不存在
        let res = testVal.slice(0, frontDecimal);
        return res;
      }
    }
  }
  if (new RegExp('^\\-?\\d*\\.?\\d{0,' + n + '}$').test(testVal)) {
    // console.log('未超出精度范围:');
    // console.log(value);
    return value;
  } if (new RegExp('^\\-?\\d*\\.?\\d*$').test(testVal)) {
    // eslint-disable-next-line prefer-template
    const dotIndex = testVal.indexOf('.');
    const res = testVal.slice(0, dotIndex + n + 1);
    // console.log('超出精度范围:');
    // console.log(res);
    return res;
  }

  return null;
}

export default {
  name: 'InputNumber',
  props: {
    max: {
      type: Number,
      default: Infinity,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    maxlength: {
      type: Number,
      default: 10,
    },
    activeChange: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Number,
      default: 1,
    },
    size: {
      validator(value) {
        return oneOf(value, ['small', 'large', 'default']);
      },
      default() {
        return !this.$IVIEW || this.$IVIEW.size === '' ? 'default' : this.$IVIEW.size;
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
    },
    precision: {
      type: Number,
    },
    elementId: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
    ifNeedCheckAllNumber: {//是否校验小数点前的字符串
      type: Boolean,
      default: false
    },
    frontDecimal: {//小数点前校验多少位
      type: Number,
    },
  },
  data() {
    return {
      focused: false,
      currentValue: this.value, // 组件当前值
    };
  },
  computed: {
    wrapClasses() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-${this.size}`]: !!this.size,
          [`${prefixCls}-disabled`]: this.disabled,
          [`${prefixCls}-focused`]: this.focused,
        },
      ];
    },
    inputWrapClasses() {
      return `${prefixCls}-input-wrap`;
    },
    inputClasses() {
      return `${prefixCls}-input`;
    },
  },
  methods: {
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        // eslint-disable-next-line prefer-spread
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast(componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params);
    },
    setValue(val) {
      let resStr;
      let resNum;
      if (val && !isNaN(this.precision)) {
        resStr = roundFun(val, this.precision, this.ifNeedCheckAllNumber, this.frontDecimal, this.activeChange);
        resNum = Number(resStr);
      } else {
        resStr = '';
        resNum = null;
      }
      const { min, max } = this;
      if (resNum !== null) {
        if (resNum > max) {
          resNum = max;
          resStr = `${max}`;
          this.$emit('maxChange', Number(val));
        } else if (resNum < min) {
          resNum = min;
          resStr = `${min}`;
          this.$emit('minChange', Number(val));
        }
      }

      this.$nextTick(() => {
        this.currentValue = resStr;
        this.$emit('input', resNum);
        this.$emit('on-change', resNum);
        this.dispatch('FormItem', 'on-form-change', resNum);
      });
    },
    focus(event) {
      this.focused = true;
      this.$emit('on-focus', event);
    },
    blur() {
      let resNum;
      if (this.currentValue !== '') {
        resNum = Number(this.currentValue);
        this.currentValue = `${resNum}`;
      } else {
        resNum = null;
        this.currentValue = '';
      }

      // console.log(`value:${resNum}`);
      this.focused = false;
      this.$emit('on-blur', resNum);
      if (!findComponentUpward(this, ['DatePicker', 'TimePicker', 'Cascader', 'Search'])) {
        this.dispatch('FormItem', 'on-form-blur', resNum);
      }
    },
    change(event) {
      if (event.type == 'change' && this.activeChange) return;
      if (event.type == 'input' && !this.activeChange) return;
      const val = event.target.value.trim();
      const isEmptyString = val.length === 0;
      if (isEmptyString) {
        this.setValue(null);
        return;
      }
      // eslint-disable-next-line no-useless-escape
      if (event.type == 'input' && val.match(/^\-?\.?$|\.$/g)) return; // prevent fire early if decimal. If no more input the change event will fire later

      // #fixed when setting the precision val, input point cannot show problem
      const precision = this.precision;
      let cacheVal = this.currentValue;
      if (precision) {
        const valMatchPointArr = (`${val}`).match(/\./g);
        if (valMatchPointArr && valMatchPointArr.length >= 2) {
          // eslint-disable-next-line prefer-template
          cacheVal = this.currentValue + '.';
        }
      }

      // val = Number(val);
      if (!isNaN(val)) {
        this.currentValue = val;
        this.setValue(val);
      } else {
        event.target.value = cacheVal;
      }
    },
  },
  watch: {
    value(val) {
      // console.log(val);
      this.currentValue = val;
    },
  },
};
</script>
